import { render } from "./BaseYellowButton.vue?vue&type=template&id=7c5b95fc"
import script from "./BaseYellowButton.vue?vue&type=script&lang=js"
export * from "./BaseYellowButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__